import { FlyingMachine } from "@/components/FlyingMachine";
import "./index.css";

export function App() {
	return <FlyingMachine />;
}

export default App;
